<template>
<div>
  <el-row class="title-bar" type="flex" :style="'justify-content:' + (operationFlag ? 'flex-end;' : 'space-between;')">
    <w-perf-analysis-time-info v-if="!operationFlag" :ref="timeInfoRef" :checkDatetime="checkDatetime" @change="onTimeTypeChange" @reload="onCurrentDataReLoad"/>
    <div class="vertical-center-box">
      <el-radio-group class="mr-r10" v-model="dataType">
        <el-radio :label="dataTypeData.tablespace" @change="onDataTypeChange">테이블스페이스</el-radio>
        <el-radio :label="dataTypeData.dataFile" @change="onDataTypeChange">데이터파일</el-radio>
      </el-radio-group>
      <w-header-search-button @click="onShowSearchButtonClick"></w-header-search-button>
    </div>
  </el-row>
  <!-- 테이블 스페이스 -->
  <el-table-wrapper v-show="dataType === dataTypeData.tablespace" v-loading="isLoading.tablespace" :data="tableData.tablespace" :columns="columns.tablespace" :pagination="true" :column-default="columnDefault" :show-custom-header="true" :show-search-tool="showSearchTool.tablespace">
    <template slot-scope="scope" slot="tablespace-userate-slot">
      <el-progress v-if="scope.row['TABLESPACE/DB_TABLESPACE_USERATE'] >= 0" :text-inside="true" :stroke-width="18" :percentage="getPercentage(scope.row['TABLESPACE/DB_TABLESPACE_USERATE'])"></el-progress>
      <span v-else> - </span>
    </template>
    <template slot-scope="scope" slot="file-info-slot">
      <i class="far fa-search-plus c-pointer" @click="onClickTablespaceShowPopup(scope.row.rscKeyName)"/>
    </template>
  </el-table-wrapper>
  <w-spaceUtilization-table-space-popup ref="spaceUtilizationSpaceSlidingPopup" :rscKeyName="tablespaceRscKeyName"/>
  <!-- 데이터 파일 -->
  <el-table-wrapper v-show="dataType === dataTypeData.dataFile" :data="tableData.dataFile" :columns="columns.dataFile" :pagination="true" :column-default="columnDefault" :show-custom-header="true" :show-search-tool="showSearchTool.dataFile">
    <template slot-scope="scope" slot="file-info-slot">
      <i class="far fa-search-plus c-pointer" @click="onClickDataFileShowPopup(scope.row.rscKeyName)"/>
    </template>
    <template slot-scope="scope" slot="datafile-userate-slot">
      <el-progress v-if="scope.row['TB_DATAFILE/DBTB_DATAFILE_USERATE'] >= 0" :text-inside="true" :stroke-width="18" :percentage="getPercentage(scope.row['TB_DATAFILE/DBTB_DATAFILE_USERATE'])"></el-progress>
      <span v-else> - </span>
    </template>
    <template slot-scope="scope" slot="datafile-userate-real-slot">
      <el-progress v-if="scope.row['TB_DATAFILE/DBTB_DATAFILE_REAL_USERATE'] >= 0" :text-inside="true" :stroke-width="18" :percentage="getPercentage(scope.row['TB_DATAFILE/DBTB_DATAFILE_REAL_USERATE'])"></el-progress>
      <span v-else> - </span>
    </template>
  </el-table-wrapper>
  <w-spaceUtilization-data-file-popup ref="spaceUtilizationFileSlidingPopup" :rscKeyName="dataFileRscKeyName" />
</div>
</template>

<script>
import { isNil, floor } from 'lodash';
import { convertValuByUnit } from '@/utils/number';
import { EMPTY_TEXT, getValueAfterCheckEmpty } from '@/utils/string';
import { columnDefault } from '@/constants/table';
import { analysisTimeType } from '@/constants/performance';
import WPerfAnalysisTimeInfo from '@/views/performance/node/analysis/components/PerfAnalysisTimeInfo';
import msgUtil from '@/utils/message';
import databaseTableInfoAPI from '@/api/performance/database/database-table-info';
import AnalysisTableMixin from '@/mixins/performance/analysis-table-ex';
import WSpaceUtilizationTableSpacePopup from '@/views/performance/node/analysis/database/popup/SpaceUtilizationTableSpacePopup';
import WSpaceUtilizationDataFilePopup from '@/views/performance/node/analysis/database/popup/SpaceUtilizationDataFilePopup';

export default {
  name: 'WSpaceUtilizationTiberoTable',
  mixins: [AnalysisTableMixin],
  components: {
    WSpaceUtilizationTableSpacePopup,
    WSpaceUtilizationDataFilePopup,
    WPerfAnalysisTimeInfo,
  },
  data() {
    return {
      dataType: 'TABLE_SPACE',
      dataTypeData: {
        tablespace: 'TABLE_SPACE',
        dataFile: 'DATA_FILE',
      },
      checkDatetime: null,
      tableData: {
        tablespace: [],
        dataFile: [],
      },
      showSearchTool: {
        tablespace: false,
        dataFile: false,
      },
      isLoading: {
        tablespace: false,
        dataFile: false,
      },
      tablespaceRscKeyName: '',
      dataFileRscKeyName: '',
      columnDefault,
      columns: {
        tablespace: [
          { prop: 'rscKeyName', label: '테이블공간명', sortable: true, searchable: true, formatter: this.getTableValueAfterCheckEmpty },
          { prop: 'TABLESPACE/DB_TABLESPACE_USERATE', label: '사용률(%)', sortable: true, scopedSlot: 'tablespace-userate-slot' },
          { prop: 'TABLESPACE/DB_TABLESPACE_TOTSIZE', label: '전체', sortable: true, formatter: this.convertMValue },
          { prop: 'TABLESPACE/DB_TABLESPACE_USEDSIZE', label: '사용량', sortable: true, formatter: this.convertMValue },
          { prop: 'TABLESPACE/DB_TABLESPACE_AVSIZE', label: '가용량', sortable: true, formatter: this.convertMValue },
          { prop: 'TB_TABLESPACE/DBTB_TABLESPACE_STATUS', label: '상태', sortable: true, searchable: true, formatter: this.getTableValueAfterCheckEmpty },
          { prop: 'TB_TABLESPACE/DBTB_TABLESPACE_INCREMENT_BY', label: '다음증가 블록', sortable: true, formatter: this.convertValue },
          { prop: 'TB_TABLESPACE/DBTB_TABLESPACE_AUTOEXTENSIBLE', label: '자동증가', sortable: true, formatter: this.getTableValueAfterCheckEmpty },
          { prop: 'TB_TABLESPACE/DBTB_TABLESPACE_MAXBYTES', label: '최대크기', sortable: true, formatter: this.convertMValue },
          { label: '파일정보', sortable: true, align: 'center', scopedSlot: 'file-info-slot', width: 83 },
        ],
        dataFile: [
          { prop: 'rscKeyName', label: '물리 파일명', sortable: true, searchable: true, formatter: this.getTableValueAfterCheckEmpty },
          { prop: 'TB_DATAFILE/DBTB_DATAFILE_USERATE', label: '사용률(%)', sortable: true, scopedSlot: 'datafile-userate-slot' },
          { prop: 'TB_DATAFILE/DBTB_DATAFILE_REAL_USERATE', label: '전체 사용률(%)', sortable: true, scopedSlot: 'datafile-userate-real-slot' },
          { prop: 'TB_DATAFILE/DBTB_DATAFILE_T_KBYTES', label: '파일 크기', sortable: true, formatter: this.convertKValue },
          { prop: 'TB_DATAFILE/DBTB_DATAFILE_T_BLOCKS', label: '전체 블록 수', sortable: true, formatter: this.convertKValue },
          { prop: 'TB_DATAFILE/DBTB_DATAFILE_USED_KBYTES', label: '파일 크기', sortable: true, formatter: this.convertKValue },
          { prop: 'TB_DATAFILE/DBTB_DATAFILE_USED_BLOCKS', label: '전체 블록 수', sortable: true, formatter: this.convertKValue },
          { prop: 'TB_DATAFILE/DBTB_DATAFILE_STATUS', label: '파일상태', sortable: true, searchable: true, formatter: this.getTableValueAfterCheckEmpty },
          { prop: 'TB_DATAFILE/DBTB_DATAFILE_AUTOEXTENSIBLE', label: '자동증가', sortable: true, width: 80, formatter: this.getTableValueAfterCheckEmpty },
          { prop: 'TB_DATAFILE/DBTB_DATAFILE_T_MAXBYTES', label: '최대 크기', sortable: true, formatter: this.convertKValue },
          { prop: 'TB_DATAFILE/DBTB_DATAFILE_READ_COUNT', label: '블록 읽기', sortable: true, formatter: this.convertKValue },
          { prop: 'TB_DATAFILE/DBTB_DATAFILE_WRITE_COUNT', label: '블록 쓰기', sortable: true, formatter: this.convertKValue },
          { prop: 'TB_DATAFILE/DBTB_DATAFILE_TOTAL_COUNT', label: '블록 읽기/쓰기', sortable: true, formatter: this.convertKValue },
          { label: '파일정보', sortable: true, align: 'center', scopedSlot: 'file-info-slot', width: 83 },
        ],
      },
    };
  },
  methods: {
    /**
     * 데이터를 로드한다.
     * @author Ju
     * @return {[type]} [description]
     */
    loadData() {
      if (this.dataType === this.dataTypeData.tablespace) {
        this.loadTablespaceData();
      } else if (this.dataType === this.dataTypeData.dataFile) {
        this.loadDataFileData();
      }
    },
    /**
     * 테이블스페이스 데이터를 로드한다.
     * @author Ju
     * @return {[type]} [description]
     */
    loadTablespaceData() {
      if (this.timeType === analysisTimeType.CURRENT.value || this.operationFlag) {
        const params = this.getCommonParamsForCurrent();
        this.isLoading.tablespace = true;
        databaseTableInfoAPI.getCurrentTablespace(params).then((result) => {
          if (result.data.success === true) {
            this.tableData.tablespace = result.data.data;
          } else {
            this.failToLoadTablespaceData();
          }
        }).catch(() => {
          this.failToLoadTablespaceData();
        }).finally(() => {
          this.isLoading.tablespace = false;
        });
      } else {
        const params = this.getCommonParamsForHist();
        this.isLoading.tablespace = true;
        databaseTableInfoAPI.getTablespaceTiberoList(params).then((result) => {
          if (result.data.success === true) {
            const snapshotData = result.data.data;
            this.tableData.tablespace = snapshotData.snapshotDoc;
            this.checkDatetime = snapshotData.timestamp;
          } else {
            this.failToLoadTablespaceData();
          }
        }).catch(() => {
          this.failToLoadTablespaceData();
        }).finally(() => {
          this.isLoading.tablespace = false;
        });
      }
    },
    /**
     * 테이블스페이스 데이터 로드 실패 처리
     * @author Ju
     * @return {[type]} [description]
     */
    failToLoadTablespaceData() {
      this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '테이블스페이스', false));
    },
    /**
     * 데이터 파일 데이터를 로드한다.
     * @author Ju
     * @return {[type]} [description]
     */
    loadDataFileData() {
      if (this.timeType === analysisTimeType.CURRENT.value || this.operationFlag) {
        const params = this.getCommonParamsForCurrent();
        this.isLoading.dataFile = true;
        databaseTableInfoAPI.getCurrentTableDatefile(params).then((result) => {
          if (result.data.success === true) {
            this.tableData.dataFile = result.data.data;
          } else {
            this.failToLoadDataFileData();
          }
        }).catch(() => {
          this.failToLoadDataFileData();
        }).finally(() => {
          this.isLoading.dataFile = false;
        });
      } else {
        const params = this.getCommonParamsForHist();
        databaseTableInfoAPI.getDatafileTiberoList(params).then((result) => {
          if (result.data.success === true) {
            const snapshotData = result.data.data;
            this.tableData.dataFile = snapshotData.snapshotDoc;
            this.checkDatetime = snapshotData.timestamp;
          } else {
            this.failToLoadDataFileData();
          }
        }).catch(() => {
          this.failToLoadDataFileData();
        }).finally(() => {
          this.isLoading.dataFile = false;
        });
      }
    },
    /**
     * 데이터 파일 로드 실패 처리
     * @author Ju
     * @return {[type]} [description]
     */
    failToLoadDataFileData() {
      this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '데이터 파일', false));
    },
    /**
     * 현재 데이터 조회 시 공통 파라미터 객체를 반환한다.
     * @author Ju
     * @return {[type]} [description]
     */
    getCommonParamsForCurrent() {
      return {
        objId: this.selectedNode.obj.objId,
        objtypeId: this.selectedNode.obj.objtypeId,
      };
    },
    /**
     * 이력 데이터 조회 시 공통 파라미터 객체를 반환한다.
     * @author Ju
     * @return {[type]} [description]
     */
    getCommonParamsForHist() {
      return {
        objId: this.selectedNode.obj.objId,
        baselineDatetime: this.plotLineDatetime,
        managetypeId: 'DBMS',
      };
    },
    /**
     * [onShowSearchButtonClick 검색 show]
     * @author {Yang}
     */
    onShowSearchButtonClick() {
      if (this.dataType === this.dataTypeData.tablespace) {
        this.showSearchTool.tablespace = !this.showSearchTool.tablespace;
      } else if (this.dataType === this.dataTypeData.dataFile) {
        this.showSearchTool.dataFile = !this.showSearchTool.dataFile;
      }
    },
    /**
     * 데이터 타입 변경 이벤트 핸들러
     * @author Ju
     * @return {[type]} [description]
     */
    onDataTypeChange() {
      this.loadData();
    },
    convertMValue(row, column, value) {
      return isNil(value) ? EMPTY_TEXT : convertValuByUnit(value, 'MB', false, false, true);
    },
    convertKValue(row, column, value) {
      return isNil(value) ? EMPTY_TEXT : convertValuByUnit(value, 'KB', false, false, true);
    },
    convertValue(row, column, value) {
      return isNil(value) ? EMPTY_TEXT : convertValuByUnit(value, null, true);
    },
    /**
     * [getPercentage 프로그래스바 * 100]
     * @author {Yang}
     * @param  {[type]} value [description]
     * @return {[type]}       [description]
     */
    getPercentage(value) {
      return isNil(value) ? 0 : floor(value, 2);
    },
    onClickTablespaceShowPopup(value) {
      this.tablespaceRscKeyName = value;
      this.$refs.spaceUtilizationSpaceSlidingPopup.open();
    },
    onClickDataFileShowPopup(value) {
      this.dataFileRscKeyName = value;
      this.$refs.spaceUtilizationFileSlidingPopup.open();
    },
    /**
     * 테이블 데이터 빈값 확인
     * @author Yang
     * @param  {Object} row
     * @param  {Object} column
     * @param  {String/Number} valu
     */
    getTableValueAfterCheckEmpty(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/performance/node/analysis/database/components/table/SpaceUtilization/SpaceUtilizationTiberoTable.vue